<mat-form-field class="permission-select" *ngIf="this.params">
    <mat-select [(value)]="this.params.data.permission" (valueChange)="onValueChange(this.params.data.permission)">
        <mat-select-trigger *ngIf="this.params.data.permission === owner">
            <svg class="icon-16 fill-cxone mr-1 mb-1">
                <use href="../App_Themes/CXone/icons/user-owner.svg#user-owner"></use>
            </svg>
            <span>{{ownerLabel}}</span>
        </mat-select-trigger>
        <mat-option [value]="owner">
            <svg class="icon-16 fill-cxone mr-2">
                <use href="../App_Themes/CXone/icons/user-owner.svg#user-owner"></use>
            </svg>
            <span>{{ownerLabel}}</span>
        </mat-option>
        <mat-option [value]="view" cvLocalizedText [langSection]="'Dashboard_Access'" [langKey]="'View_Only'">View Only</mat-option>
    </mat-select>
    <svg class="icon-12 fill-permission">
        <use href="../App_Themes/CXone/icons/arrow-down.svg#arrow-down">
    </use></svg>
</mat-form-field>
